/* ==========================================================================
   VEY'S REDESIGN — carousel dots for the product-recommendations carousel
   ("You may also like…"). The theme's carousel-slider shows an OverlayScrollbars
   progress bar; the redesign hides it (custom-product.css) and this adds proper
   page dots instead — matching the site's other carousels. Recommendations load
   via AJAX, so a MutationObserver catches the carousel when it's injected.
   Scoped to .cc-product-recommendations so no other carousel is affected.
   ========================================================================== */
(function () {
  var SEL = '.cc-product-recommendations carousel-slider, .cart-page-recommendations carousel-slider';

  function initDots(carousel) {
    if (carousel.__ccDotsInit) return;
    var slider = carousel.querySelector('.slider');
    var slides = carousel.querySelectorAll('.slider__item');
    if (!slider || slides.length < 2) return;
    carousel.__ccDotsInit = true;

    var dotsWrap = document.createElement('div');
    dotsWrap.className = 'cc-carousel-dots';
    carousel.appendChild(dotsWrap);

    var metrics = { span: 0, perPage: 1, pages: 1 };

    function measure() {
      var first = slides[0];
      var second = slides[1] || slides[0];
      var span = Math.abs(second.offsetLeft - first.offsetLeft) || first.offsetWidth || 1;
      var perPage = Math.max(1, Math.round(slider.clientWidth / span));
      var pages = Math.max(1, Math.ceil(slides.length / perPage));
      metrics = { span: span, perPage: perPage, pages: pages };
    }

    function currentPage() {
      var pageWidth = metrics.perPage * metrics.span;
      if (pageWidth <= 0) return 0;
      return Math.max(0, Math.min(metrics.pages - 1, Math.round(slider.scrollLeft / pageWidth)));
    }

    function updateActive() {
      var cur = currentPage();
      var dots = dotsWrap.children;
      for (var i = 0; i < dots.length; i++) {
        var on = i === cur;
        dots[i].classList.toggle('is-active', on);
        dots[i].setAttribute('aria-current', on ? 'true' : 'false');
      }
    }

    function onDotClick(e) {
      var i = parseInt(e.currentTarget.getAttribute('data-page'), 10) || 0;
      slider.scrollTo({ left: i * metrics.perPage * metrics.span, behavior: 'smooth' });
    }

    function render() {
      measure();
      if (metrics.pages < 2) { dotsWrap.style.display = 'none'; return; }
      dotsWrap.style.display = '';
      if (dotsWrap.children.length !== metrics.pages) {
        dotsWrap.textContent = '';
        for (var i = 0; i < metrics.pages; i++) {
          var b = document.createElement('button');
          b.type = 'button';
          b.className = 'cc-carousel-dot';
          b.setAttribute('data-page', i);
          b.setAttribute('aria-label', 'Go to slide group ' + (i + 1));
          b.addEventListener('click', onDotClick);
          dotsWrap.appendChild(b);
        }
      }
      updateActive();
    }

    var scrollRAF;
    slider.addEventListener('scroll', function () {
      if (scrollRAF) cancelAnimationFrame(scrollRAF);
      scrollRAF = requestAnimationFrame(updateActive);
    }, { passive: true });

    var resizeT;
    window.addEventListener('resize', function () {
      clearTimeout(resizeT);
      resizeT = setTimeout(render, 200);
    });

    render();
    // Card images load late and shift widths → re-measure a couple of times.
    setTimeout(render, 400);
    setTimeout(render, 1200);
    if (document.fonts && document.fonts.ready) document.fonts.ready.then(render);
  }

  function scan(root) {
    var nodes = (root || document).querySelectorAll(SEL);
    for (var i = 0; i < nodes.length; i++) initDots(nodes[i]);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { scan(); });
  } else {
    scan();
  }

  // Recommendations inject their carousel via AJAX after load.
  var mo = new MutationObserver(function (muts) {
    for (var i = 0; i < muts.length; i++) {
      var added = muts[i].addedNodes;
      for (var j = 0; j < added.length; j++) {
        var n = added[j];
        if (n.nodeType !== 1) continue;
        if (n.matches && n.matches(SEL)) initDots(n);
        if (n.querySelectorAll) scan(n);
      }
    }
  });
  mo.observe(document.documentElement, { childList: true, subtree: true });
})();
